export const DEFAULT_USER_CREATE_FORM = {
  firstName: "",
  lastName: "",
  phone: "",
  oldEmail: "",
  email: "",
  password: "",
  passwordConfirm: "",
  active: "",
  role: "owner",
  recieveCharacterizationMail: false,
  recieveCharacterizationPush: false,
  recieveCharacterizationSms: false,
  recieveQualicheckMail: false,
  recieveQualicheckPush: false,
  recieveQualicheckSms: false,
  receiveAnomalyMail: false,
  receiveAnomalyPush: false,
  receiveAnomalySms: false,
  receiveFillingMail: false,
  receiveFillingPush: false,
  receiveFillingSms: false,
  receiveRotationMail: false,
  receiveRotationPush: false,
  receiveRotationSms: false,
  receiveDowngradeMail: false,
  receiveDowngradePush: false,
  receiveDowngradeSms: false,
  receiveDailyPerformanceReport: false,
  token: "",
  authorizedAddresses: [],
};
